import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f465502"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"75%"},
  src: "icons/resume.png"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"55%"},
  src: "icons/linkedin.png"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"55%"},
  src: "icons/github.png"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"65%"},
  src: "icons/email.png"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.screen == 'phone' ? 'mt-3' : 'wordPadder', "flex justify-start"])
  }, [
    _createElementVNode("a", {
      href: "https://drive.google.com/file/d/1lDNvOOdFEK7pW9aBqJB7iF7L73emIsEs/view?usp=sharing",
      class: "contactBox flex justify-center items-center",
      target: "_blank",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logContactIconClick('resume')))
    }, _hoisted_2),
    _createElementVNode("a", {
      href: "https://www.linkedin.com/in/emmettmyers/",
      class: "contactBox flex justify-center items-center",
      target: "_blank",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logContactIconClick('linkedin')))
    }, _hoisted_4),
    _createElementVNode("a", {
      href: "https://github.com/EmmettMyers",
      class: "contactBox flex justify-center items-center",
      target: "_blank",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logContactIconClick('github')))
    }, _hoisted_6),
    _createElementVNode("a", {
      href: "mailto:emmettleemyers@gmail.com?subject=&body=",
      class: "contactBox flex justify-center items-center",
      target: "_blank",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logContactIconClick('email')))
    }, _hoisted_8)
  ], 2))
}